import { render } from "./BusquedaAvanzadaMedicamentos.vue?vue&type=template&id=d2a1724a&scoped=true"
import script from "./BusquedaAvanzadaMedicamentos.vue?vue&type=script&lang=js"
export * from "./BusquedaAvanzadaMedicamentos.vue?vue&type=script&lang=js"

import "./BusquedaAvanzadaMedicamentos.vue?vue&type=style&index=0&id=d2a1724a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a1724a"]])

export default __exports__